import Cookies from "universal-cookie";

const BASE_URL = "https://bsp-backend-xqdx.onrender.com/api";
// const BASE_URL = "https://localhost:7091/api";

const getHeaders = () => {
    const cookies = new Cookies();
    const jwt = cookies.get("jwt");

    let headers = {
        "Content-Type": "application/json",
    }

    if (jwt) {
        headers = { ...headers, "Authorization": `Bearer ${jwt}` };
    }

    return headers;
}

function get(endpoint, options = {}) {
    const requestOptions = {
        method: 'GET',
        headers: getHeaders(),
        ...options
    };
    return fetch(`${BASE_URL}/${endpoint}`, requestOptions).then(handleResponse);
}

function post(endpoint, body) {
    const requestOptions = {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(body)
    };
    return fetch(`${BASE_URL}/${endpoint}`, requestOptions).then(handleResponse);
}

function postFormData(endpoint, body) {
    const headers = getHeaders();

    const requestOptions = {
        method: 'POST',
        headers: headers.Authorization ? { Authorization: headers.Authorization } : {},
        body: body
    };

    return fetch(`${BASE_URL}/${endpoint}`, requestOptions).then(handleResponse);
}

function put(endpoint, body) {
    const requestOptions = {
        method: 'PUT',
        headers: getHeaders(),
        body: JSON.stringify(body)
    };
    return fetch(`${BASE_URL}/${endpoint}`, requestOptions).then(handleResponse);
}

function _delete(endpoint) {
    const requestOptions = {
        method: 'DELETE',
        headers: getHeaders()
    };
    return fetch(`${BASE_URL}/${endpoint}`, requestOptions).then(handleResponse);
}

function download(endpoint) {
    const requestOptions = {
        method: 'GET',
        headers: getHeaders(),
        responseType: 'blob'
    };
    return fetch(`${BASE_URL}/${endpoint}`, requestOptions)
        .then(res => {
            if (res.ok) {
                return Promise.resolve(res.blob());
            }

            return Promise.reject("Error when downloading");
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            const error = (data && data.errors) || response.statusText;
            return Promise.reject(error);
        }

        return Promise.resolve(data || null);
    });
}

export const Backend = {
    get,
    post,
    postFormData,
    put,
    delete: _delete,
    download
};

